import { getAuth, setPersistence, inMemoryPersistence } from 'firebase/auth';
import { doc, getFirestore, onSnapshot } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import firebaseConfig from './config';

let firebaseInstance;

function FirebaseFactory(app) {
  const auth = getAuth(app);

  // (async () => setPersistence(auth, inMemoryPersistence))()

  const rtdb = getDatabase(app);

  const fsdb = getFirestore(app, firebaseConfig.databaseId);

  const storage = getStorage(app);
  const questionImagesStorage = getStorage(
    app,
    'gs://kol-exchange-question-images'
  );
  const sessionDocumentsStorage = getStorage(
    app,
    'gs://kol-exchange-session-documents'
  );

  const functions = getFunctions(app, 'europe-west1');

  if (process.env.NODE_ENV === 'development') {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    // Using live Realtime Database instead of emulator
  }

  const subscribeToUserUpdates = ({ uid, snapshot }) =>
    onSnapshot(doc(fsdb, 'users', uid), snapshot);

  const subscribeToSessionUpdates = ({ id, snapshot }) =>
    onSnapshot(doc(fsdb, 'sessions', id), snapshot);

  return {
    auth,
    rtdb,
    fsdb,
    storage,
    questionImagesStorage,
    sessionDocumentsStorage,
    functions,
    subscribeToUserUpdates,
    subscribeToSessionUpdates
  };
}

function getFirebaseInstance(app) {
  if (!firebaseInstance && app) {
    firebaseInstance = FirebaseFactory(app);
    return firebaseInstance;
  }

  if (firebaseInstance) {
    return firebaseInstance;
  }

  return null;
}

export default getFirebaseInstance;
